export default __webpack_public_path__ + "static/media/fuwenben_s.9549efbd.png";